
































import {Component, Vue, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import ShardListTable from '@/components/lfs/NewShardList/ShardListTable.vue'
import SelectedShard from '@/components/lfs/NewShardList/SelectedShard.vue'
import Toolbar from '@/components/lfs/NewShardList/Toolbar.vue'
import Tooltip from '@/components/UI/Tooltip.vue';
import INotes from '@/components/icons/INotes.vue'
import ISurveyNew from '@/components/icons/ISurveyNew.vue'
import IFire from '@/components/icons/IFire.vue'


const newshards = namespace('newshards')

@Component({
  components: {
    ShardListTable,
    SelectedShard,
    Toolbar,
    Tooltip,
    'i-notes': INotes,
    'i-survey-new': ISurveyNew,
    'i-fire': IFire,
  }
})

export default class CurrentShardList extends Vue {
  @newshards.Action('loadShardFromServer') protected loadShardFromServer: any
  @newshards.Getter('shard') protected shard: any
  @newshards.Action('saveShardFromServer') protected saveShardFromServer: any
  @newshards.Mutation('clearStore') protected clearStore: any
  @newshards.Getter('shards') protected shards: any


  updateFilter: boolean = false
  isSelectedShard: boolean = false
  menuDatePicker: boolean = false

  isArchiveChange(payload: any) {
    console.log(payload)
    this.saveShardFromServer(
      {
        id: payload.id,
        params: {
          isArchived: payload.isArchived
        }
      }
    )
  }

  changeMenuDatePicker(menu:boolean) {
    this.menuDatePicker = menu
  }

  selectShard(shard: any) {
    this.loadShardFromServer(shard.id)
    this.isSelectedShard = true
  }

  showTable() {
    this.isSelectedShard = false
  }

  // destroyed() {
  //   this.clearStore()
  // }

  updateFilterFun(val:any) {
    this.updateFilter = true
    setTimeout(() => {
      this.isSelectedShard = false
      this.updateFilter = false
    }, 0)
  }

}
